import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "@firebase/util";
import { getAuth } from "firebase/auth";
import { authenticateUser } from "../../redux/reducers/UserReducer";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";

import BarChart from "./BarChart";
import VerticalPieChart from "./VerticalPieChart";
import TableStudentScore from "./TableStudentScore";
import ExportExcelContainer from "./ExportExcelContainer";

import { getAllScoreGrade, getAllContentTS } from "../../api/DashboardApi";
import s from "./style.module.css";

const classArray = [
  { id: 1, label: "ป.4", value: 4 },
  { id: 2, label: "ป.5", value: 5 },
  { id: 3, label: "ป.6", value: 6 },
  { id: 4, label: "ภาพรวม", value: 0 },
];

const styles = {
  barStyle: {
    width: "25vw",
    height: "35vh",
    padding: "15px",
    margin: "10px 5px 0px 0px",
    backgroundColor: "#fff",
    boxShadow: "0px 3px 4px rgba(0, 0, 0, 0.25)",
  },
};
const DashboardContainer = () => {
  const auth = getAuth();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const userInfo = useSelector((state) => state.UserInfo);
  const userId = localStorage.getItem("authUser");
  const logout = (e) => {
    auth.signOut().then((response) => {
      dispatch(authenticateUser({ ...userInfo }));
    });
    localStorage.removeItem("authUser");
    navigate("/");
  };
  const [selectedClass, setSelectedClass] = useState("4");
  const [selectedWeek, setSelectedWeek] = useState(1);
  const [selectedGender, setSelectedGender] = useState(3);
  const [barScore4, setBarScore4] = useState([]);
  const [barScore5, setBarScore5] = useState([]);
  const [barScore6, setBarScore6] = useState([]);
  const [allStudentAnswer4, setAllStudentAnswer4] = useState([]);
  const [allStudentAnswer5, setAllStudentAnswer5] = useState([]);
  const [allStudentAnswer6, setAllStudentAnswer6] = useState([]);
  const [contentTsG4, setContentTsG4] = useState([]);
  const [contentTsG5, setContentTsG5] = useState([]);
  const [contentTsG6, setContentTsG6] = useState([]);

  const handleGetClass = (value) => {
    setSelectedClass(value);
  };
  const handleChangeGender = (e) => {
    setSelectedGender(e);
  };
  useEffect(() => {
    getAllScoreGrade(4, selectedWeek).then((res) => {
      const data = res.filter((item) => !isEmpty(item));
      setBarScore4(data.map((item2) => item2[0].data.score));
      // setAllStudentAnswer4(data.map((item2) => item2[0].data.allAnswer));
      setAllStudentAnswer4(data.map((item2) => item2[0]));
    });
    getAllScoreGrade(5, selectedWeek).then((res) => {
      const data = res.filter((item) => !isEmpty(item));
      setBarScore5(data.map((item2) => item2[0].data.score));
      setAllStudentAnswer5(data.map((item2) => item2[0]));
    });
    getAllScoreGrade(6, selectedWeek).then((res) => {
      const data = res.filter((item) => !isEmpty(item));
      setBarScore6(data.map((item2) => item2[0].data.score));
      setAllStudentAnswer6(data.map((item2) => item2[0]));
    });
    getAllContentTS(4, selectedWeek).then((res) => {
      const data = res.filter((item) => !isEmpty(item));
      setContentTsG4(data.map((item) => item[0]));
    });
    getAllContentTS(5, selectedWeek).then((res) => {
      const data = res.filter((item) => !isEmpty(item));
      setContentTsG5(data.map((item) => item[0]));
    });
    getAllContentTS(6, selectedWeek).then((res) => {
      const data = res.filter((item) => !isEmpty(item));
      setContentTsG6(data.map((item) => item[0]));
    });
  }, [selectedWeek, selectedClass]);
  const calcullateMeanLoop = (grade) => {
    const data = grade === 4 ? barScore4 : grade === 5 ? barScore5 : barScore6;
    let sum = 0;
    for (let i = 0; i < data.length; i++) {
      sum += data[i];
    }
    const mean = Math.round(sum / data.length);
    return mean;
  };

  const handleCalculateMean = () => {
    const meanGrade4 = calcullateMeanLoop(4);
    const meanGrade5 = calcullateMeanLoop(5);
    const meanGrade6 = calcullateMeanLoop(6);
    return { grade4: meanGrade4, grade5: meanGrade5, grade6: meanGrade6 };
  };

  const countOccurrences = (arr, val) =>
    arr.reduce((a, v) => (v === val ? a + 1 : a), 0);

  const calculateFunc = (e) => {
    const allPercent = [];
    for (let i = 0; i < e.length; i++) {
      const count = countOccurrences(e[i], true);
      // const calculate = (count / e[i].length) * 100;
      allPercent.push(count);
    }
    return allPercent;
  };

  const CalculateVerticalBar = (grade) => {
    const stuGrad4Data = allStudentAnswer4.map((item) => item.data.allAnswer);
    const stuGrad5Data = allStudentAnswer5.map((item) => item.data.allAnswer);
    const stuGrad6Data = allStudentAnswer6.map((item) => item.data.allAnswer);
    const allStudentInGrade =
      grade === 4 ? stuGrad4Data : grade === 5 ? stuGrad5Data : stuGrad6Data;
    if (allStudentInGrade.length > 0) {
      const test = [];
      const allAnsInFb = [].concat.apply([], allStudentInGrade);
      for (let i = 0; i <= allStudentInGrade[0].length - 1; i++) {
        const every1Ans = allAnsInFb.filter(
          (item) => item.question_id === i + 1
        );
        test.push(every1Ans.map((item) => item.answer_id));
      }
      return calculateFunc(test);
    }
  };

  const calculateMeanGender = (data) => {
    let sum = 0;
    let mean = 0;
    for (let i = 0; i < data.length; i++) {
      sum += data[i];
    }
    mean = Math.round(sum / data.length);
    return mean;
  };
  const calculateByGender = () => {
    const data =
      selectedClass === "4"
        ? allStudentAnswer4
        : selectedClass === "5"
        ? allStudentAnswer5
        : allStudentAnswer6;
    const boyArray = data.filter((item) => item.user[0] === "b");
    const girlArray = data.filter((item) => item.user[0] === "g");
    const allScore = data.map((item) => item.data.score);
    const boysScore = boyArray.map((item) => item.data.score);
    const girlsScore = girlArray.map((item) => item.data.score);
    const boysMean = calculateMeanGender(boysScore);
    const girlsMean = calculateMeanGender(girlsScore);
    const allMean = calculateMeanGender(allScore);
    return {
      grade4: boysMean,
      grade5: girlsMean,
      grade6: allMean,
      boyNum: boyArray.length,
      girlNum: girlArray.length,
      AllNum: data.length,
    };
  };

  const onCheckDataArray = () => {
    const testArray = [];
    if (allStudentAnswer4.length === contentTsG4.length) {
      testArray.push({ id: 1, data: allStudentAnswer4, content: contentTsG4 });
    }
    if (allStudentAnswer5.length === contentTsG5.length) {
      testArray.push({ id: 2, data: allStudentAnswer5, content: contentTsG5 });
    }
    if (allStudentAnswer6.length === contentTsG6.length) {
      testArray.push({ id: 3, data: allStudentAnswer6, content: contentTsG6 });
    }
    return testArray;
  };
  if (userId === null || userId !== "teacher@test.com") {
    // not logged in so redirect to login page with the return url
    navigate("/");
    return <div>please login as a teacher...</div>;
  }
  return (
    <div className={s.Container}>
      <div className={s.BackgroundImg} />
      <div className={s.DashboardContainer}>
        <div className={s.leftContainer}>
          {/* <div className={s.leftContent}>User Profile</div> */}
          <div className={s.leftContent}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span>ระดับชั้นเรียนของนักเรียน</span>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <RadioGroup
                  onChange={(e) => handleGetClass(e.target.value)}
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue={selectedClass}
                  name="radio-buttons-group"
                >
                  {classArray.map((item) => (
                    <FormControlLabel
                      value={item.value}
                      control={<Radio />}
                      label={item.label}
                    />
                  ))}
                </RadioGroup>
              </div>
            </div>
          </div>
          <div className={s.leftContent}>
            <Button onClick={() => logout()} variant="outlined" color="error">
              ออกจากระบบ
            </Button>
            {/* <button>ออกจากระบบ</button> */}
          </div>
        </div>
        <div className={s.rightContainer}>
          <div className={s.rightContent}>
            <Box style={{ marginLeft: "15px" }} sx={{ minWidth: 220 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  สัปดาห์ที่
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  label="ระยะเวลาของการเรียน"
                  id="demo-simple-select"
                  defaultValue={1}
                  onChange={(e) => setSelectedWeek(e.target.value)}
                >
                  <MenuItem value={1}>สัปดาห์ที่ 1 </MenuItem>
                  <MenuItem value={2}>สัปดาห์ที่ 2 </MenuItem>
                  <MenuItem value={3}>สัปดาห์ที่ 3 </MenuItem>
                  <MenuItem value={4}>สัปดาห์ที่ 4 </MenuItem>
                  <MenuItem value={5}>สัปดาห์ที่ 5 </MenuItem>
                  <MenuItem value={6}>สัปดาห์ที่ 6 </MenuItem>
                </Select>
              </FormControl>
            </Box>
            {selectedClass !== "0" && (
              <Box style={{ marginLeft: "15px" }} sx={{ minWidth: 220 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">เพศ</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    label="เพศ"
                    id="demo-simple-select"
                    defaultValue={selectedGender}
                    value={selectedGender}
                    onChange={(e) => handleChangeGender(e.target.value)}
                  >
                    <MenuItem value={1}>เพศชาย </MenuItem>
                    <MenuItem value={2}>เพศหญิง </MenuItem>
                    <MenuItem value={3}>ทั้งหมด </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
            {selectedClass === "0" && (
              <Box style={{ marginLeft: "15px" }} sx={{ minWidth: 220 }}>
                <ExportExcelContainer
                  selectedWeek={selectedWeek}
                  dataArray={onCheckDataArray()}
                />
              </Box>
            )}
          </div>
          {selectedClass === "0" ? (
            <React.Fragment>
              <div className={s.rightContent}>
                <BarChart
                  numGrade4={barScore4.length}
                  numGrade5={barScore5.length}
                  numGrade6={barScore6.length}
                  dataArray={handleCalculateMean()}
                />
              </div>
              <div className={s.rightContent}>
                <div style={styles.barStyle}>
                  <VerticalPieChart
                    correctArr={CalculateVerticalBar(4)}
                    grade={4}
                    StuNum={allStudentAnswer4.length}
                  />
                </div>
                <div style={styles.barStyle}>
                  <VerticalPieChart
                    correctArr={CalculateVerticalBar(5)}
                    grade={5}
                    StuNum={allStudentAnswer5.length}
                  />
                </div>
                <div style={styles.barStyle}>
                  <VerticalPieChart
                    correctArr={CalculateVerticalBar(6)}
                    grade={6}
                    StuNum={allStudentAnswer6.length}
                  />
                </div>
              </div>
            </React.Fragment>
          ) : (
            <div className={s.rightContent} style={{ overflowY: "scroll" }}>
              <div>
                <div
                  style={{
                    backgroundColor: "#fffdef",
                    border: "2px solid #e3aa49",
                  }}
                >
                  <BarChart
                    typeGender
                    numGrade4={calculateByGender().boyNum}
                    numGrade5={calculateByGender().girlNum}
                    numGrade6={calculateByGender().AllNum}
                    dataArray={calculateByGender()}
                  />
                </div>
                <TableStudentScore
                  selectedClass={selectedClass}
                  selectedWeek={selectedWeek}
                  selectedGender={selectedGender}
                  dataTable={
                    selectedClass === "4"
                      ? allStudentAnswer4
                      : selectedClass === "5"
                      ? allStudentAnswer5
                      : allStudentAnswer6
                  }
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardContainer;
